import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/button'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './style.scss'

const messages = {
  error: [
    'CATEGORY_LOAD_MORE_ERROR',
    "Couldn't load more products.",
    'โหลดสินค้าเพิ่มเติมไม่สำเร็จ',
  ],
  loading: [
    'CATEGORY_LOAD_MORE_LOADING',
    'Loading more products…',
    'กำลังโหลดสินค้าเพิ่มเติม...',
  ],
}

const LoadMoreStatus = ({ status, onRetry, t, isThai }) => {
  if (status === 'idle' || status === 'done') return null
  const pending = status === 'loading' || status === 'retrying'
  const showRetry = status === 'error' || status === 'retrying'
  const [key, english, thai] = messages[status] || messages.loading
  const message = hasLocizeTranslation(t, key, isThai ? thai : english)

  return (
    <div className="workwear-load-more" aria-busy={pending}>
      <style jsx>{styles}</style>
      <p role="status" aria-live="polite">
        {message}
      </p>
      {showRetry && (
        <Button
          onClick={onRetry}
          disabled={pending}
          style={{ minHeight: 44, minWidth: 120 }}
        >
          {hasLocizeTranslation(
            t,
            'CATEGORY_LOAD_MORE_RETRY',
            isThai ? 'ลองอีกครั้ง' : 'Retry',
          )}
        </Button>
      )}
    </div>
  )
}

LoadMoreStatus.defaultProps = { isThai: false }
LoadMoreStatus.propTypes = {
  status: PropTypes.oneOf(['idle', 'loading', 'retrying', 'error', 'done'])
    .isRequired,
  onRetry: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isThai: PropTypes.bool,
}
export default LoadMoreStatus
